"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _models = require("@seedlang/models");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// Note: Logger is only available in mobile, not in shared packages
// import Logger from '../../mobile/utils/logger';

var TriviaCardWrapper = function TriviaCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "opponentTurn", _descriptor, _this);
      _initializerDefineProperty(_this, "myTurn", _descriptor2, _this);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor3, _this);
      _initializerDefineProperty(_this, "toggledSentenceType", _descriptor4, _this);
      _initializerDefineProperty(_this, "bothScoresSubmitted", _descriptor5, _this);
      _initializerDefineProperty(_this, "userCardUpdatedAt", _descriptor6, _this);
      _initializerDefineProperty(_this, "correct", _descriptor7, _this);
      _initializerDefineProperty(_this, "timerStartedAt", _descriptor8, _this);
      _initializerDefineProperty(_this, "lastLocalUpdatedAt", _descriptor9, _this);
      _initializerDefineProperty(_this, "initialVideoPlayFinished", _descriptor0, _this);
      _this.afterInitialPlay = function () {
        _this.initialVideoPlayFinished = true;
        if (!_this.props.userCard.timerInitiated || _state.DeckUI.reviewDeck) {
          _this.initiateTimer();
        }
      };
      _this.initiateTimer = function () {
        _state.DeckUI.userCardStore.update({
          ids: {
            userCardId: _this.props.userCard.id
          },
          data: {
            timer_initiated: true,
            seen: true
          }
        }, _lodash.noop);
        _this.props.userCard.set('timerInitiated', true);
        if (!_state.DeckUI.reviewDeck) {
          _state.AppUI.soundEffectStore.play('countDown');
        }
        var timerStartedAt = +new Date();
        _this.opponentTurn.initiateTimer(timerStartedAt);
        _this.myTurn.initiateTimer(timerStartedAt);
        _this.interval = setInterval(_this.decrementTimer.bind(_this), _constants.Constants.TRIVIA_TIMER_INTERVAL);
      };
      _this.timeOut = function () {
        _this.answerSelected(false);
        _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
        _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
          secondsElapsed: _this.myTurn.secondsElapsed
        });
      };
      _this.onCorrectOpponentTurn = function () {
        _state.AppUI.soundEffectStore.play('correctOpponent');
        if (_this.myTurn.timerStoppedAt) {
          _this.setBothScoresSubmitted();
        }
      };
      _this.onIncorrectOpponentTurn = function () {
        _state.AppUI.soundEffectStore.play('failureOpponent');
        if (_this.myTurn.timerStoppedAt) {
          _this.setBothScoresSubmitted();
        }
      };
      _this.onToggleSentenceType = function () {
        _this.sentence.state.onReset();
        _this.toggledSentenceType = !_this.toggledSentenceType || _this.toggledSentenceType === 'answer' ? 'question' : 'answer';
      };
      _this.clearSelection = function () {
        _this.multipleChoiceSelected = null;
      };
      _this.onClick = function (option) {
        if (!_this.myTurn.timerStoppedAt) {
          option.set('selectedCount', option.selectedCount + 1);
          _this.multipleChoiceSelected = option.id;
          _this.props.cardState.selectedOptionText = option.text || option.targetText || option.sourceText || option.id;
          _this.answerSelected(option.correct);
          if (option.correct) {
            var _DeckUI$userDeck;
            _this.props.userCard.set('points', _this.myTurn.points);
            _this.props.userCard.set('pointsSubmitted', true);
            if (typeof ((_DeckUI$userDeck = _state.DeckUI.userDeck) === null || _DeckUI$userDeck === void 0 ? void 0 : _DeckUI$userDeck.calculatePoints) === 'function') {
              _state.DeckUI.userDeck.calculatePoints();
            }
            _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
              xp: 2,
              xpSlug: 'trivia',
              points: _this.myTurn.points,
              multipleChoiceOptionId: option.id,
              secondsElapsed: _this.myTurn.secondsElapsed
            });
          } else {
            _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
              multipleChoiceOptionId: option.id,
              secondsElapsed: _this.myTurn.secondsElapsed
            });
          }
          _this.correct = option.correct;
          setTimeout(function () {
            return _state.DeckUI.reveal(_this.props.card, _this.props.cardState, _this.props.userCard);
          }, 500);
        }
      };
      _this.setBothScoresSubmitted = function () {
        _state.AppUI.soundEffectStore.pause('countDown');
        setTimeout(function () {
          return _this.setBothScoresSubmittedDelayed();
        }, 500);
      };
      _this.setBothScoresSubmittedDelayed = function () {
        _this.bothScoresSubmitted = true;
        _this.props.userCard.set('seen', true);
      };
      _this.answerSelected = function (correct) {
        _this.correct = correct;
        _this.myTurn.stopTimer(correct);
        if (_this.opponentInactive) {
          _this.setBothScoresSubmitted();
        }
      };
      _this.stopTimer = function () {
        clearInterval(_this.interval);
        _this.opponentTurn.stopTimer();
        _this.myTurn.stopTimer();
      };
      _this.decrementTimer = function () {
        _this.myTurn.updateTimerProgress();
        _this.opponentTurn.updateTimerProgress();
        if (!_this.myTurn.timerActive && _this.opponentInactive) {
          _this.stopTimer();
        }
      };
      _this.onReset = function () {
        _this.multipleChoiceSelected = null;
        _this.toggledSentenceType = 'answer';
        _this.bothScoresSubmitted = false;
        _this.userCardUpdatedAt = null;
        _this.correct = null;
        _this.timerStartedAt = null;
        _this.myTurn = new _models.PlayerTurn(_this, true);
        _this.opponentTurn = new _models.PlayerTurn(_this, false);
      };
      _state.DeckUI.enrichSentence(_this.props.card);
      _this.myTurn = new _models.PlayerTurn(_this, true);
      _this.opponentTurn = new _models.PlayerTurn(_this, false);
      _this.opponentTurn.set('pastPerformance', _this.pastPerformance);
      _this.lastLocalUpdatedAt = _this.props.userCard.localUpdatedAt;
      _this.disposer = (0, _mobx.autorun)(function () {
        if (_state.DeckUI.reviewDeck && _this.props.inView && _this.props.userCard.localUpdatedAt !== _this.lastLocalUpdatedAt && _state.DeckUI.userDeck.numActiveUserCards === 2) {
          _this.lastLocalUpdatedAt = _this.props.userCard.localUpdatedAt;
          _this.onReset();
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.disposer && this.disposer();
        clearInterval(this.interval);
        this.stopTimer();
      }
    }, {
      key: "hasOpponent",
      get: function get() {
        return (0, _utils.isPresent)(this.opponentUserDeck);
      }
    }, {
      key: "opponentUserDeck",
      get: function get() {
        return _state.DeckUI.userDeck && _state.DeckUI.userDeck.opponentUserDeck;
      }
    }, {
      key: "opponent",
      get: function get() {
        return this.hasOpponent ? this.opponentUserDeck.user : null;
      }
    }, {
      key: "opponentPoints",
      get: function get() {
        var _this2 = this;
        if (this.hasOpponent && this.opponentTurn.pastPerformance && _state.DeckUI.userDeck) {
          var points = _state.DeckUI.userDeck.opponentUserDeck.userCards.filter(function (item) {
            return item.position < _this2.props.userCard.position;
          }).map(function (item) {
            return item.points;
          }).reduce(function (a, b) {
            return a + b;
          }, 0);
          points = this.props.userCard && this.props.userCard.seen ? points + this.opponentTurn.pastPerformance.points : points + this.opponentTurn.points;
          return points > _state.DeckUI.userDeck.opponentUserDeck.points ? _state.DeckUI.userDeck.opponentUserDeck.points : points;
        }
      }
    }, {
      key: "borderColor",
      get: function get() {
        if (this.myTurn.correct) {
          return _constants.Theme.green;
        } else if (this.myTurn.correct === false) {
          return _constants.Theme.red;
        } else {
          return '#565656';
        }
      }
    }, {
      key: "questionVideoClip",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.targetVideoClip;
      }
    }, {
      key: "correctAnswerVideoClip",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.answer.correctVideoClip;
      }
    }, {
      key: "incorrectAnswerVideoClip",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.answer.incorrectVideoClip;
      }
    }, {
      key: "videoClipType",
      get: function get() {
        var _this3 = this;
        var result = function () {
          if (_this3.sentenceType === 'answer' && _this3.showSentence && _this3.props.userCard.correct) {
            return 'correct-answer';
          }
          if (_this3.sentenceType === 'answer' && _this3.showSentence && _this3.props.userCard.correct === false) {
            return 'incorrect-answer';
          } else {
            return 'question';
          }
        }();

        // Debug logging only works in mobile components, not shared packages
        // TriviaLogger.log(`videoClipType computed: ${result} (sentenceType=${this.sentenceType}, showSentence=${this.showSentence}, userCardCorrect=${this.props.userCard.correct}, bothScoresSubmitted=${this.bothScoresSubmitted})`);

        return result;
      }
    }, {
      key: "pastPerformance",
      get: function get() {
        if (this.hasOpponent && _state.DeckUI.userDeck && (0, _utils.isPresent)(_state.DeckUI.deck.cards)) {
          var cardIndex = _state.DeckUI.deck.cards.map(function (item) {
            return item.id;
          }).indexOf(this.props.card.id);
          if (_state.DeckUI.userDeck.opponentUserDeck.userCards.length >= cardIndex) {
            return _state.DeckUI.userDeck.opponentUserDeck.userCards[cardIndex];
          }
        }
      }
    }, {
      key: "timerActive",
      get: function get() {
        return this.myTurn.timerActive || this.opponentTurn.timerActive;
      }
    }, {
      key: "opponentInactive",
      get: function get() {
        return !this.hasOpponent || this.opponentTurn.timerStoppedAt;
      }
    }, {
      key: "sentenceType",
      get: function get() {
        return this.showSentence ? this.toggledSentenceType : 'question';
      }
    }, {
      key: "questionOrAnswer",
      get: function get() {
        return this.sentenceType === 'answer' && this.props.card.sentence && this.props.card.sentence.answer ? this.props.card.sentence.answer : this.props.card.sentence;
      }
    }, {
      key: "sentence",
      get: function get() {
        return (0, _utils.isPresent)(this.props.card) ? this.questionOrAnswer : {};
      }
    }, {
      key: "showSentence",
      get: function get() {
        return this.bothScoresSubmitted || !_state.DeckUI.reviewDeck && this.props.userCard.seen && this.props.userCard.timerInitiated;
      }
    }, {
      key: "showWordCard",
      get: function get() {
        return this.props.inView && this.sentence.state && this.sentence.selectedWordAssociation;
      }
    }, {
      key: "icons",
      get: function get() {
        return ['cardComments', 'toggleReview', 'languageButton'];
      }
    }, {
      key: "reviewIcons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentence: this.sentence,
          borderColor: this.borderColor,
          afterInitialPlay: this.afterInitialPlay,
          videoClip: this.videoClip,
          questionVideoClip: this.questionVideoClip,
          correctAnswerVideoClip: this.correctAnswerVideoClip,
          incorrectAnswerVideoClip: this.incorrectAnswerVideoClip,
          videoClipType: this.videoClipType,
          showSentence: this.showSentence,
          onToggleSentenceType: this.onToggleSentenceType,
          sentenceType: this.sentenceType,
          onClick: this.onClick,
          multipleChoiceSelected: this.multipleChoiceSelected,
          opponentTurn: this.opponentTurn,
          myTurn: this.myTurn,
          opponentPoints: this.opponentPoints,
          hasOpponent: this.hasOpponent,
          opponent: this.opponent,
          showWordCard: this.showWordCard,
          correct: this.correct,
          initialVideoPlayFinished: this.initialVideoPlayFinished,
          reviewIcons: this.reviewIcons,
          icons: this.icons
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "opponentTurn", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "myTurn", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "toggledSentenceType", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'answer';
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "bothScoresSubmitted", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "userCardUpdatedAt", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "timerStartedAt", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "lastLocalUpdatedAt", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "initialVideoPlayFinished", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "hasOpponent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasOpponent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponentUserDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponentUserDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponentPoints", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponentPoints"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "borderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "questionVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "questionVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "incorrectAnswerVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "incorrectAnswerVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoClipType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoClipType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pastPerformance", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pastPerformance"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "timerActive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "timerActive"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponentInactive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponentInactive"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentenceType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentenceType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "questionOrAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "questionOrAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewIcons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewIcons"), _class2.prototype), _class2)) || _class;
};
TriviaCardWrapper.displayName = 'TriviaCardWrapper';
var _default = exports["default"] = TriviaCardWrapper;